import React from "react";

import {
  Dialog,
  DialogContent,
  DialogHeading,
  DialogClose,
  IconButton,
  Button,
} from "components/LibraryComponents/Components";
import { Icon } from "@trussworks/react-uswds";

import styles from "./VerifyBusiness.module.scss";

type ClaimedDialogProps = {
  open: boolean;
  errorMessage: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function VerifyBusinessErrorDialog(props: ClaimedDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.setOpen}>
      <DialogContent className={styles["verify-error-dialog-root"]} hasBackdrop>
        <div className={styles["verify-error-dialog-body"]}>
          <div className={styles["header"]}>
            <DialogHeading className={styles["heading"]}>
              Failed to claim business
            </DialogHeading>

            <IconButton
              type="button"
              Icon={<Icon.Close aria-hidden="true" />}
              size="sm"
              onClick={() => props.setOpen(false)}
              tabIndex={-1}
              aria-label="Close dialog"
            />
          </div>
          <div className={styles["verify-error-content"]}>
            <p>{props.errorMessage}</p>
          </div>
        </div>

        <div className={styles["verify-error-dialog-footer"]}>
          <Button
            type="submit"
            className={styles["btn-close"]}
            aria-label="Export results to CSV"
            onClick={() => props.setOpen(false)}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
